import React from 'react';
import { GoX } from 'react-icons/go';

import { ColorPalette } from 'theme/colors';

import { TagContainer, Content } from './styles';

export type Props = {
  children: React.ReactNode;
  onDelete: () => void;
};

const FilterTag = ({ children, onDelete }: Props) => (
  <TagContainer onClick={onDelete}>
    <Content>{children}</Content>
    <GoX color={ColorPalette.HEX.White} />
  </TagContainer>
);

export default FilterTag;
